import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_52839)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1416 41.377H0.860352C0.381836 41.377 0.000976562 40.9863 0.000976562 40.5176V9.48242C0.000976562 9.00391 0.391602 8.62305 0.860352 8.62305H49.1318C49.6104 8.62305 49.9912 9.01367 49.9912 9.48242V40.5176C50.001 40.9961 49.6104 41.377 49.1416 41.377Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1426 41.377H0.861328C0.382813 41.377 0.00195312 40.9863 0.00195312 40.5176V36.2109H50.002V40.5176C50.002 40.9961 49.6113 41.377 49.1426 41.377Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.861328 8.62305H49.1328C49.6113 8.62305 49.9922 9.01367 49.9922 9.48242V13.7891H0.00195312V9.48242C0.00195312 9.00391 0.392578 8.62305 0.861328 8.62305Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.001 18.9648H0.000976562V31.0352H50.001V18.9648Z",
					fill: "#41479B"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_52839",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgThFlag);
export { ForwardRef as ReactComponent };
